import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { signIn, getResetTimers } from "../services/auth";

interface AuthState {
  status: string;
  isLoggedIn: boolean;
  isResetTimers: boolean;
  cognitoUserId: string;
}

const initialState: AuthState = {
  status: "idle",
  isLoggedIn: false,
  isResetTimers: false,
  cognitoUserId: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.status = "pending";
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.status = "success";
        state.isLoggedIn = true;
        // fallback value
        state.cognitoUserId = "no@email";

        // email is returned in the list of user attributes response
        if (Array.isArray(action.payload)) {
          state.cognitoUserId =
            action.payload[1]?.email ??
            action?.payload[0]?.username ??
            "no@email";
        }
      })
      .addCase(signIn.rejected, (state) => {
        state.status = "rejected";
        state.isLoggedIn = false;
        state.cognitoUserId = "";
      })
      .addCase(getResetTimers, (state, action) => {
        state.isResetTimers = action.payload as unknown as boolean;
      });
  },
});

export default authSlice.reducer;
